import type { FormikTouched } from "formik";
import { z } from "zod";

const lineKinds = ["expense", "income"] as const;
const accessScopes = ["read", "write"] as const;

export const lineKindOptions = [
    { value: "expense", label: "Expense" },
    { value: "income", label: "Income" },
] as const;

/** An inline line-item row (`labelHidden`) and heading-named fields. */
export const labellessFieldsPlaygroundSchema = z.object({
    labelless: z.object({
        description: z.string().trim().min(1, "Describe the line"),
        amount: z.number().positive("Enter an amount above zero"),
        date: z.string(),
        kind: z.enum(lineKinds),
        isBillable: z.boolean(),
        scope: z.enum(accessScopes),
        depositAccountId: z
            .number()
            .nullable()
            .refine((id): boolean => id !== null, {
                message: "Pick an account",
            }),
        isReceiptOn: z.boolean(),
    }),
});

type LabellessFieldsPlaygroundValues = z.infer<
    typeof labellessFieldsPlaygroundSchema
>;

export const labellessFieldsPlaygroundInitialValues: LabellessFieldsPlaygroundValues =
    {
        labelless: {
            description: "Office rent",
            amount: 0,
            date: "2026-09-24",
            kind: "expense",
            isBillable: false,
            scope: "read",
            depositAccountId: null,
            isReceiptOn: true,
        },
    };

/** Starts the amount and deposit account touched so their errors show. */
export const labellessFieldsPlaygroundInitialTouched: FormikTouched<LabellessFieldsPlaygroundValues> =
    { labelless: { amount: true, depositAccountId: true } };
